module.exports = __webpack_public_path__ + "img/case52.6f4da719.png";